function initFormCondo(conteneur) {
    init_change_event(conteneur)
    initSelect2Lots()
    initOuvrirFermerAccordeonCondo()
    initRechercheUeCondo()
    initModalRechercheCondo()
    initGenererMatricule()

    $(".cb-all-gen-matricule").off('click').on('click', function() {
        let is_checked = $(this).is(":checked")
        $('.cb-gen-matricule').prop('checked', is_checked)
    })

    $('#btn-creer-ue-condo').off('click').on('click', function() {
        $('#modal-step-contents').slimScroll({scrollTo: $('#modal-step-contents')[0].scrollHeight, animate: true});
    })
}

function initOuvrirFermerAccordeonCondo() {
    $('#modal-recherche-condo, .blocForm').off('click', '.accordion-toggle').on('click', '.accordion-toggle', function () {
        let div_container = $(this).closest('.panel').find('.form-condo-collapse .panel-body')
        if (div_container.children().length > 0) return
        $.ajax({
            headers: {},
            type: 'GET',
            url: '/gestion-roles/get-form-condo/' + div_container.data('instance'),
            data: {'id_evenement': div_container.data('evenement')},
            async: true,
            success: function (response) {
                div_container.html(response)
                initFormCondo(div_container)
            },
            error: function (jqXHR, textStatus, errorThrown) {

            }
        });
    })
}

function initRechercheUeCondo () {
    $('#recherche-ue-condo').off('click').on('click', function () {
        $.ajax({
            type: "GET",
            url: "/gestion-roles/tenue-a-jour/recherche-ue-condo/" + $("#wizard").attr('id-municipalite') + `/`,
            data: $("#ue-form-condo-search").serialize(),
            dataType: 'html',
            success: function (response) {
                var nb_recherche = $(response).find('#exp-ue-resultat-recherche-nb').val();
                var ajouter = false;
                if (ajouter) {
                    $(response).find('a').each(function () {

                        var id = $(this).attr('id-ue');
                        if (!$("#" + id).length) {
                            // on insère seulement ceux qui ne sont pas déjà dans la liste
                            var is_in = true;
                            $('#condo-div-resultat').find('a').each(function () {
                                var idResultat = $(this).attr('id-ue');
                                if (id == idResultat) {
                                    is_in = false;
                                }
                            });
                            if (is_in) {
                                $('#condo-div-resultat').append($($.parseHTML(response)).filter('#' + $(this).parents(':eq(1)').attr("id")));
                            }
                        }
                    });

                    wait.stop('div-resultat');


                    if (nb_recherche >= maxRecherche) {
                        $('#exp-ue-recherche-nb').text('Seulement les ' + maxRecherche + ' premiers sont affichés');
                        $('#exp-ue-recherche-nb').addClass("red");
                    } else {
                        $('#exp-ue-recherche-nb').text($('#condo-div-resultat > div').length - 1 + ' élément(s)'); // y comprend pas pourquoi pour le moins -1
                        $('#exp-ue-recherche-nb').removeClass("red");
                    }

                } else {
                    $('#condo-div-resultat').html('').append(response);
                    wait.stop('condo-div-resultat');

                    if (nb_recherche >= maxRecherche) {
                        $('#exp-ue-recherche-nb').text('Seulement les ' + maxRecherche + ' premiers sont affichés');
                        $('#exp-ue-recherche-nb').addClass("red");
                    } else {
                        $('#nb-recherche-resultat').text(nb_recherche);
                        $('#exp-ue-recherche-nb').removeClass("red");
                    }
                }

                // s'il y a la municipalité dans l'étape, on met à jour la municipalité selon le dernier résultat de la liste de recherche
                var municipaliteUeResultat = $(response).find('#exp-ue-resultat-recherche-municipalite-ue').val();
                var municipaliteSelect = $('#contenu').find('.step-pane.active').find('#municipalite');
                if (municipaliteSelect.length && municipaliteSelect.select2("val") != municipaliteUeResultat) {
                    municipaliteSelect.select2("val", municipaliteUeResultat);
                    municipaliteSelect.trigger('change');
                }

                $('#condo-div-resultat').off('click', 'button').on('click', 'button', function () {

                    var id = $(this).attr('id');
                    if (response.length != 0) {
                        var element = "#" + id.replace("-x", "") + "_div";
                    }

                    $(this).closest(element).remove();
                    $('#exp-ue-recherche-nb').text($('#condo-div-resultat > div').length + ' élément(s)');

                    $('.banniere').remove(); //pour eviter de desactiver la close de la banniere

                    return false;
                });
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                //$('#aucun-resultat').html('').append(getBanniereMessage('', 'Aucune propriété ne correspond à votre recherche.'));
                $('#exp-ue-recherche-nb').text('Aucune propriété ne correspond à votre recherche.');
                $('#exp-ue-recherche-nb').addClass("red");
            }
        });
    });
}

function initModalRechercheCondo() {
    $("#modal-recherche-condo").off('click', '.div-list-group-item-content').on('click', '.div-list-group-item-content', function () {
        let is_checked = $(this).find('input[type="checkbox"]').is(":checked");
        $(this).find('input[type="checkbox"]').prop('checked', !is_checked);
        $('#btn-ajouter-ue-form').prop('disabled', $("#condo-div-resultat").find('input[type="checkbox"]:checked').length === 0)
    });

    $("#modal-recherche-condo").off('click', "#btn-ajouter-ue-form").on('click', "#btn-ajouter-ue-form", function () {
        if ($("#condo-div-resultat").find('input[type="checkbox"]:checked').length === 0) return false
        ajouterUeForm()
    })

    $("#modal-recherche-condo").on('hidden.bs.modal', function() {
        $('body').addClass('modal-open')
    })
}

function serialize_data_condo(form, data) {
    $(form).serializeArray().map(function (item) {
        if (data[item.name]) {
            if (typeof (ue_data[item.name]) === "string") {
                data[item.name] = [config[item.name]];
            }
            data[item.name].push(item.value);
        } else {
            data[item.name] = item.value;
        }
    });
}

// callback: c'est la fonction à exécuter lorsque l'exécution du save est terminé (que ce soit une réussite ou un échec)
function saveCondos(conteneur, callback) {
    let reponse = {};
    let data = []
    $.each(conteneur.find('.row-parent').not('.nouvelle-ligne'), function (idx_ue, ue) {
        if ($(ue).find('.valeur-modifiee').length === 0) return true
        var ue_data = {}

        effacerErreursCondo($(ue), true);
        if ($(ue).attr("methode") === "POST" || $(ue).attr("methode") === "PATCH") {
            serialize_data_condo($(ue).find('form.form-condo'), ue_data)
            var lots = []
            $.each($(ue).find('.row-enfant').not('.nouvelle-ligne'), function (idx_ue, lot) {
                if ($(lot).find('form.form-lot').find('.valeur-modifiee').length == 0) return true
                var data_lot = {}
                effacerErreursCondo($(lot), true);
                serialize_data_condo($(lot).find('form.form-lot'), data_lot)
                lots.push(data_lot)
            })
            ue_data['lots'] = lots
        }

        if ($(ue).attr("methode") === "DELETE") {
            serialize_data_condo($(ue).find('form.form-condo'), ue_data)
        }
        data.push(ue_data)
    })

    let params = {
        id_evenement: $('#wizard').attr('id-evenement'),
        data: JSON.stringify(data),
    }

    $.ajax({
        type: 'POST',
        url: '/gestion-roles/tenue-a-jour/save-operation-ue-condo/',
        data: params,
        dataType: 'json',
        async: true,
        success: function (res) {
            if (!res.valid) {
                $('#condo-general-error').removeClass('hidden')
                $('#condo-general-error').html(res.msg)
                $('#modal-step-contents').slimScroll({scrollTo: 0, animate: true});
            }
            infos.ajouterMessageToast({
                message: res.msg,
                messageDuree: 0,
                icone: res.valid ? 'fa-check-circle-o': 'fa-exclamation-triangle',
                iconeCouleur: res.valid ? 'green' : 'orange'
            });
            wait.stop();
            $('#spin-contenu').remove();
            if ($('#modal-step-contents > .active').attr('recharger') == "oui"){
                $('#btn-wizard-recharger').click()
            }
            else {
                callback({'reponse': 'ok'})
            }

        },
        error: function (jqXHR) {
            wait.stop();
            $('#spin-contenu').remove();

            if (jqXHR.status === 400) {
                // d'abord, effacer les erreurs qui sont déjà affichées
                $('.step-pane.active').find('.has-error').removeClass('has-error');
                $('.step-pane.active').find('.alert.alert-danger').addClass('hidden').find('span').html('');
                var respListe = jqXHR.responseJSON
                $.each(respListe, function(index, resp) {
                    var bloc = $('.step-pane.active').find('.row-parent[id-model-instance="' + resp.id + '"]').not('.nouvelle-ligne')
                    if (resp.errors) {
                        $.each(resp.errors, function(cle, valeur) {
                            let input = bloc.find('[name="' + cle + '"]');
                            $(input).parent().addClass('has-error');
                            let sibling = $(input).siblings();
                            $(sibling).removeClass('hidden');
                            $(sibling).find('span').html(valeur);
                        });
                    }
                    if (resp.erreurs_lots) {
                        $.each(resp.erreurs_lots, function (index, erreurs) {
                            var row = bloc.find('[id-model-instance="' + erreurs.id + '"].row-enfant').not('.nouvelle-ligne')
                            $.each(erreurs.errors, function (cle, valeur) {
                                let input = row.find('[name="' + cle + '"]');
                                $(input).parent().addClass('has-error');
                                let sibling = $(input).siblings().not('.select2-container');
                                $(sibling).removeClass('hidden');
                                $(sibling).find('span').html(valeur[0]);
                            });
                        });
                    }
                });
            }
            if (jqXHR.status >= 400 && jqXHR.status < 500) {
                var erreur = $.parseJSON(jqXHR.responseText);
                let message = "Erreur de sauvegarde" + (erreur.message_erreur ? " : " + erreur.message_erreur : '');
                infos.ajouterMessageToast({
                    message: message,
                    messageDuree: 0,
                    type: 'error',
                    messageCouleur: 'red'
                });
            } else {
                var responseText = jqXHR.responseText;
                if (responseText) {
                    var baliseErreurEvb = 'ERREUR_EVB:';
                    var indexBaliseEvbDebut = responseText.indexOf(baliseErreurEvb);

                    if (indexBaliseEvbDebut != -1) {
                        var indexBaliseEvbFin = responseText.indexOf('^^^', indexBaliseEvbDebut);
                        var texteErreurEvb = responseText.substring(indexBaliseEvbDebut + baliseErreurEvb.length, indexBaliseEvbFin);
                        erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', '', texteErreurEvb);
                    }
                }

                infos.ajouterMessageToast({
                    message: 'Une erreur s\'est produite. Contactez un administrateur.',
                    messageDuree: 0,
                    type: 'error',
                });
                //TODO : logguer les erreurs
            }
            nbErreurs = 1;

            if (typeof (callback) != 'undefined') {
                reponse.reponse = 'error';
                callback(reponse);
            }
        }
    });
}

function initSelect2Lots() {

    $('select.no-lots').select2();

    $('input.no-lots').select2({
        ajax: {
            url: '/gestion-roles/get-no-lots/' + $('#wizard').attr('id-evenement') + '/',
            dataType: 'json',
            quietMillis: 500,
            placeholder: 'Search for a repository',
            data: function (search_term, arg2) {
                return {
                    search: search_term
                };
            },
            results: function (data, arg2, arg3) {
                return {
                    results: data
                };
            },

        },
        minimumInputLength: 3,
        // dropdownAutoWidth: true,
        initSelection: function (element, callback) {
            // si on met à jour l'élément avec select2('val', ...) depuis formatSelection, alors, il passe ici pour retourner l'information
            var data = {id: element.val(), text: element.val()};
            if (element.attr('warning')) {
                data.warning = element.attr('warning');
            }
            callback(data);
        },
        formatSelection: function (data, container, escapeMarkup) {
            var element = this.element;

            effacerErreursCondo(element.closest('form'))
            if (data.warning) {
                // garder le warning sur l'élément pour le remettre si le champ est nettoyé
                element.attr('warning', data.warning)
            }
            if (element.attr('warning')) {
                afficherWarningNoLot(element, element.attr('warning'))
            }
            return $.fn.select2.defaults.formatSelection(data, container, escapeMarkup);
        },
    });
}

function init_change_event(container) {
    var selecteur;
    if (typeof (container) == 'undefined') {
        selecteur = $(':input.form-control');
    } else {
        selecteur = container.find(':input.form-control');
    }

    $.each(selecteur.filter('select.no-lots'), function() {
        afficherWarningNoLot($(this), $(this).find('option:selected').attr('warning'));
    });

    $(selecteur).off('change').on('change', function (e) {
        var ctrl = $(e.target);
        $('#modal-step-contents > .active').attr('recharger', 'oui')
        if (ctrl.closest('.row-enfant').length && ctrl.hasClass('no-lots')){
            if (ctrl.val() === '') {
                let input_superficie = ctrl.closest('.row-enfant').find('input[name="superficie"]')
                input_superficie.val('')
                input_superficie.removeAttr('readonly')
                return;
            }
            let no_lot_existant = ctrl.closest('.form-condo-cadastre').find('.no-lots').not(ctrl).filter(function(i, e) {
                return $(e).val() === ctrl.val();
            }).length > 0
            if (no_lot_existant) {
                infos.ajouterMessageToast({
                    message: "Un lot ne peut être associé plus d'une fois à la même unité d'évaluation",
                    messageDuree: 2000,
                    icone: 'fa-exclamation-triangle',
                    iconeCouleur: 'orange'
                })
                return;
            }

            afficherWarningNoLot(ctrl, ctrl.find('option:selected').attr('warning'));

            let matriculeCourtUe = ctrl.closest('.row-parent').find('.form-condo [name="matricule_court"]');
            if (matriculeCourtUe.val() === '') {
                let matriculeCourtUeOrigine = $('#modal-step-contents > .active').find('.form-condo-collapse.matricule-court-origine .panel-body').data('matricule-court-origine');
                if (matriculeCourtUeOrigine) {
                    matriculeCourtUe.val(matriculeCourtUeOrigine).trigger('change');
                }
            }

            $.ajax({
                type: 'GET',
                url: '/gestion-roles/get-superficie-lot/' + $("#wizard").attr('id-municipalite') + '/',
                data: {
                    id_evenement: $('#wizard').attr('id-evenement'),
                    no_lot: ctrl.val()
                },
                success: function (response) {
                    if (response.superficie) {
                        let input_superficie = ctrl.closest('.row-enfant').find('input[name="superficie"]')
                        input_superficie.attr('readonly', 'readonly')
                        input_superficie.attr('data-original-title', 'Cette superficie est gérée automatiquement car elle provient du cadastre')
                        input_superficie.val(response.superficie)
                    }
                },
            });
        }
        let ctrlDansSuppressionLigne = ctrl.is('.formset_parent input:checkbox.form-control.' + CLASSE_CONTROLE_SUPPRESSION)
        if (ctrlDansSuppressionLigne) {
            // On vérifie si la case est cochée sur une ligne de section multiple et on indique la suppression éventuelle avec une barre horizontale sur la ligne
            var ctrlRow = ctrl.closest('.row-enfant').length === 0 ? ctrl.closest('.row-parent'): ctrl.closest('.row-enfant')
            var ctrlIsChecked = ctrl.is(':checked')
            var ctrlRowIcone = ctrlRow.find('i');

            // on toggle sur la classe de suppression de ligne
            var listeDiv = getDivSuppressionCondo(ctrlRow);
            listeDiv.toggleClass(CLASSE_SUPPRESSION_LIGNE, ctrlIsChecked);

            var idModelInstance = ctrlRow.attr('id-model-instance');
            if (listeDiv.hasClass(CLASSE_SUPPRESSION_LIGNE_SAUVEGARDEE) && idModelInstance === 'None') {
                listeDiv.removeClass(CLASSE_SUPPRESSION_LIGNE_SAUVEGARDEE);
                var inputFile = ctrlRow.find('input:file');
                if (inputFile.length > 0) {
                    ctrlRow.find('[name="description"]').addClass(CLASSE_VALEUR_MODIFIEE);
                } else {
                    ctrlRow.find(':input:not(button)').first().addClass(CLASSE_VALEUR_MODIFIEE);
                }
            }

            ctrlRow.find('input').toggleClass(CLASSE_VALEUR_MODIFIEE, true)
            if (ctrlIsChecked)
                ctrlRowIcone.removeClass('fa-square-o').addClass('fa-trash-o');
            else
                ctrlRowIcone.removeClass('fa-trash-o').addClass('fa-square-o');

            // on toggle sur le disabled des contrôles de la ligne pour ne pas pouvoir modifier les valeurs tant que la ligne est cochée
            listeDiv.find(':input:not(.input-disabled), label.for-ctrl-checkbox').attr('readonly', ctrlIsChecked)

            // on toggle sur la méthode : utiliser dans le wizard, étape 1: documents
            ctrlRow.attr('methode', function (index, valeur) {
                if (valeur === 'PATCH' || valeur === 'POST') {
                    return 'DELETE';
                }
                return ctrlRow.attr('id-model-instance') === 'None' ? 'POST' : 'PATCH';
            });


            if (ctrl.hasClass('suppression-parent')) {
                var rowsEnfant = ctrlRow.find('.row-enfant')
                rowsEnfant.each(function () {
                    var row = $(this)
                    var idModelInstance = row.attr('id-model-instance');
                    if (listeDiv.hasClass(CLASSE_SUPPRESSION_LIGNE_SAUVEGARDEE) && idModelInstance === 'None') {
                        listeDiv.removeClass(CLASSE_SUPPRESSION_LIGNE_SAUVEGARDEE);
                        row.find(':input:not(button)').first().addClass(CLASSE_VALEUR_MODIFIEE);
                    }

                    row.attr('methode', function (index, valeur) {
                        if (valeur === 'PATCH' || valeur === 'POST') {
                            return 'DELETE';
                        }
                        return ctrlRow.attr('id-model-instance') === 'None' ? 'POST' : 'PATCH';
                    });
                })

            }
            $('#btn-wizard-save').attr('disabled', false)
        } else {

            appliquerChangementCondo(ctrl);
            if (ctrl.closest('.' + CLASSE_NOUVELLE_LIGNE).length) {
                if (ctrl.closest('.' + CLASSE_NOUVELLE_LIGNE).hasClass('row-parent')) {
                    ajouterNouveauBloc(ctrl)
                } else if (ctrl.closest('.' + CLASSE_NOUVELLE_LIGNE).hasClass('row-enfant')) {
                    ajouterNouvelleLigne(ctrl);
                }
            }

            if (!ctrl.is('.form-control.' + CLASSE_CONTROLE_CHECKBOX)) return

            let ctrlIcone = $(ctrl).parent().find('i');
            if (ctrl.is(':checked')) {
                ctrlIcone.removeClass('fa-square-o').addClass('fa-check-square-o');
            } else {
                ctrlIcone.removeClass('fa-check-square-o').addClass('fa-square-o');
            }
            // on met le checked/unchecked dans l'attribut 'value'
            var valueFalse = ctrl.attr('value_false');
            ctrl.val(ctrl.is(':checked') ? 1 : valueFalse != undefined ? valueFalse : 0);
        }
    });
}

function getSousFormOuSousContainerImmediats(champsMultiple, classe) {
    var selecteur = '.' + classe;

    var rowsImmediats = champsMultiple.find(selecteur).filter(function () {
        return !$(this).parentsUntil(champsMultiple, '.champs-multiple').length;
    });

    return rowsImmediats;
}

// utilisé lorsqu'on crée une nouvelle ligne, suite à un changement de valeur dans l'ancienne nouvelle ligne ...
function dupliquerNouveauSousContainer(sousContainer) {
    var nouvelleLigne = sousContainer.next();
    var nouveauSousContainer = sousContainer.clone(true);
    var champsMultipleImmediat = getSousFormOuSousContainerImmediats(nouveauSousContainer, 'champs-multiple');
    var sousFormsImmediats = getSousFormOuSousContainerImmediats(champsMultipleImmediat, 'sous-bloc-form');
    var nouveauSousContainerNouvelleLigne = sousFormsImmediats.filter('.nouvelle-ligne');
    var elemsAvant = nouveauSousContainerNouvelleLigne.prevAll('.sous-bloc-form');
    elemsAvant.remove();

    nouvelleLigne.after(nouveauSousContainer);
}

function getDivSuppressionCondo(ligne) {
    var divs = ligne.find('.form-control').closest('div')

    return divs.filter(function () {
        return $(this).find(':input').not('input:hidden').length > 0;
    });
}

function appliquerChangementCondo(controle) {
    // On vérifie si la "valeur" est différente de la "valeur de défaut" et on met une couleur de fond différente
    // On n'efface pas la couleur de fond si on a sauvegardé au moins une fois

    if ($('#wizard').length > 0 || controleEstModifie(controle)) {
        marquerChangement(controle);
    } else {
        effacerChangement(controle, true);
    }
    $('#btn-wizard-save').attr('disabled', false)
}

function marquerChangement(controle, afficherPortraitAnterieur) {
    // ne pas marquer le changement sur les contrôles ayant la classe 'exception-save'
    controle = controle.not('.exception-save');
    if (!controle.length)
        return
    afficherPortraitAnterieur = typeof afficherPortraitAnterieur !== 'undefined' ? afficherPortraitAnterieur : false;

    if (!afficherPortraitAnterieur) {
        controle.addClass(CLASSE_VALEUR_MODIFIEE);
    }

    if (typeof getInputSelectSimple !== 'undefined') {
        // si on trouve un input sur un select, c'est le input qui aura la couleur de fond
        var ctrlInput = getInputSelectSimple(controle);
        if (ctrlInput != null) {
            controle = ctrlInput;
        }
    }

    if (typeof CLASSE_CONTROLE_MODIFIE !== 'undefined') {
        controle.addClass(CLASSE_CONTROLE_MODIFIE);
        // appliquer le changement sur l'icone du checkbox en plus du checkbox lui-même
        if (controle.is('.' + CLASSE_CONTROLE_CHECKBOX)) {
            controle.parent().find('i').addClass(CLASSE_CONTROLE_MODIFIE);
        }
    }
}

function effacerChangement(controle, verifierSauvegarde) {
    verifierSauvegarde = typeof verifierSauvegarde !== 'undefined' ? verifierSauvegarde : false;

    var estSauvegarde = false;
    if (verifierSauvegarde) {
        if (controle.is('.form-control.' + CLASSE_VALEUR_SAUVEGARDEE)) {
            estSauvegarde = true;
        }
    }

    controle.removeClass(CLASSE_VALEUR_MODIFIEE);

    if (typeof getInputSelectSimple !== 'undefined') {
        // si on trouve un input sur un select, c'est le input à qui on efface la couleur de fond si ce n'est pas sauvegardé
        var ctrlInput = getInputSelectSimple(controle);
        if (ctrlInput != null) {
            controle = ctrlInput;
        }
    }

    if (typeof CLASSE_CONTROLE_MODIFIE !== 'undefined') {
        if (!estSauvegarde && !controle.hasClass(CLASSE_PORTRAIT_ANTERIEUR)) {
            controle.removeClass(CLASSE_CONTROLE_MODIFIE);
            if (controle.is('.' + CLASSE_CONTROLE_CHECKBOX)) {
                controle.parent().find('i').removeClass(CLASSE_CONTROLE_MODIFIE);
            }
        }
    }
}

function ajouterNouveauBloc(controle, chercherNouvelleLigne) {
    var ligneCourante = $(controle).closest('.' + CLASSE_NOUVELLE_LIGNE);

    var accordion = ligneCourante.closest('.panel-group');

    $(ligneCourante).find('.select2-ajax').select2("destroy");

    var nouveau_accordion = $(accordion).clone(true);
    var nouvelleLigne = $(nouveau_accordion).find('.nouvelle-ligne')

    $(accordion).find('.row-parent.nouvelle-ligne').removeClass('nouvelle-ligne')

    var ctrlInput = $(nouveau_accordion).find(':input.form-control').not('input[type=hidden].form-control');
    ctrlInput.val('').prop('defaultValue', '');
    ctrlInput.not('.input-disabled, .select-disabled, [name$="qualiteComplexite"]').attr('disabled', false);
    ctrlInput.attr('title', '');

    let new_counter = $(nouveau_accordion).find('.form-condo-collapse .panel-body').data('counter') + 1
    $(nouveau_accordion).find('.form-condo-collapse .panel-body').data('counter', new_counter)
    $(nouveau_accordion).find('.accordion-toggle').attr('href', '#collapse-' + new_counter).attr('href', '#collapse-' + new_counter).attr('aria-controls', 'collapse-' + new_counter)
    $(nouveau_accordion).find('.form-condo-collapse .panel-body').attr('id', 'collapse-' + new_counter).data('counter', new_counter)
    if (typeof effacerChangement !== 'undefined') effacerChangement(ctrlInput);
    disableControleSuppression(nouvelleLigne, chercherNouvelleLigne);
    $(nouveau_accordion).find('div').removeClass(CLASSE_SUPPRESSION_LIGNE).removeClass(CLASSE_SUPPRESSION_LIGNE_SAUVEGARDEE);
    $(nouvelleLigne).attr('id-model-instance', 'None');

    erreursAjax.effacerErreurChamps($(nouvelleLigne));

    $(accordion).after(nouveau_accordion);

    disableControleSuppression(ligneCourante, false);
    if (chercherNouvelleLigne) {
        $(ligneCourante).removeClass(CLASSE_NOUVELLE_LIGNE);
    }

    initSelect2($(ligneCourante));
    initFormCondo($(nouveau_accordion))


    // s'assurer de ne pas copier l'icône X du checkbox de suppression
    nouvelleLigne.find('.ctrl-suppression').next('i').removeClass('fa-trash-o fa-square-o').addClass('fa-square-o');

    return $(nouvelleLigne);
}

function ajouterNouvelleLigne(controle, chercherNouvelleLigne) {
    var ligneCourante = $(controle).closest('.' + CLASSE_NOUVELLE_LIGNE);

    $(ligneCourante).find('.select2-ajax').select2("destroy");

    var nouvelleLigne = $(ligneCourante).clone()

    $(ligneCourante).removeClass('nouvelle-ligne')

    var ctrlInput = $(nouvelleLigne).find(':input.form-control').not('input[type=hidden].form-control');
    ctrlInput.val('').prop('defaultValue', '');
    ctrlInput.not('.input-disabled, .select-disabled, [name$="qualiteComplexite"]').attr('disabled', false);
    ctrlInput.attr('title', '');
    if (typeof effacerChangement !== 'undefined') effacerChangement(ctrlInput);
    disableControleSuppression(nouvelleLigne, chercherNouvelleLigne);
    $(ligneCourante).find('div').removeClass(CLASSE_SUPPRESSION_LIGNE).removeClass(CLASSE_SUPPRESSION_LIGNE_SAUVEGARDEE);
    $(nouvelleLigne).attr('id-model-instance', 'None');

    erreursAjax.effacerErreurChamps($(nouvelleLigne));
    effacerErreursCondo($(nouvelleLigne));
    $(ligneCourante).after(nouvelleLigne);

    disableControleSuppression(ligneCourante, false);
    if (chercherNouvelleLigne) {
        $(ligneCourante).removeClass(CLASSE_NOUVELLE_LIGNE);
    }

    initSelect2($(ligneCourante))
    initFormCondo($(nouvelleLigne))

    // s'assurer de ne pas copier l'icône X du checkbox de suppression
    nouvelleLigne.find('.ctrl-suppression').next('i').removeClass('fa-trash-o fa-square-o').addClass('fa-square-o');

    return $(nouvelleLigne);
}

function ajouterUeForm() {
    //on sauvegarde parce qu'on recharge la page suite à l'ajout
    wait.start()
    let ues = []
    $("#condo-div-resultat").find('input[type="checkbox"]:checked').map(function(i, elem) {
        ues.push($(elem).data('id_ue'))
    })
    $.ajax({
        headers: {},
        type: 'POST',
        url: '/gestion-roles/add-ue-condo/',
        traditional: true,
        data: {
            ues: ues,
            id_evenement: $('#wizard').attr('id-evenement'),
        },
        async: true,
        success: function (resp) {
            if (resp.valid) {
                $("#modal-recherche-condo").modal('hide')
                $('#modal-step-contents > .active').attr('recharger', 'oui')
                saveCondos($('.step-pane.active'))
            } else {
                infos.ajouterMessageToast({
                    message: resp.msg,
                    messageDuree: 10000,
                    icone: 'fa-exclamation-triangle',
                    iconeCouleur: 'orange'
                });
                wait.stop()
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            wait.stop()
        }
    });
}

function initGenererMatricule() {
    $("#btn-generer-matricule").off('click').on("click", function () {
        var liste_id = []
        var liste_matricule = []

        $('.cb-gen-matricule:checked').each(function (idx, e) {
            liste_id.push($(e).data('id'))
            liste_matricule.push($(e).data('matricule'))

        })
        if (liste_id.length === 0) {
            infos.ajouterMessageToast({
                message: "Vous devez choisir au moins une unité d'évaluation pour générer un nouveau matricule",
                icone: 'fa-exclamation-triangle',
                messageDuree: 10000,
                iconeCouleur: 'orange'
            });
        } else {
            wait.start()
            $.ajax({
                type: 'POST',
                url: '/gestion-roles/generer-matricule-condo/' + $('#wizard').attr('id-evenement') + '/',
                traditional: true,
                data: {
                    liste_id: liste_id,
                    liste_matricule: liste_matricule,
                },
                success: function (resp) {
                    if (resp.valid === false) {
                        infos.ajouterMessageToast({
                            message: resp.msg,
                            type: 'error',
                            messageDuree: 10000,
                            icone: 'fa-exclamation-triangle',
                            iconeCouleur: 'orange'
                        });
                    } else {
                        infos.ajouterMessageToast({
                            message: resp.msg,
                            icone: 'fa-check-circle-o',
                            messageDuree: 10000,
                            iconeCouleur: 'green'
                        });
                        $('#btn-wizard-recharger').click()
                    }
                    wait.stop()
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    wait.stop()
                }
            });
        }
    });
}

function effacerErreursCondo(form, garderWarning=false) {
    var ctrlInput = form.find(':input.form-control[name="no_lot"]').not('input[type=hidden].form-control');

    ctrlInput.parent().removeClass('has-error').removeClass('has-warning')
    if (!garderWarning) {
        ctrlInput.attr('warning', '')
    }
    let sibling = ctrlInput.siblings().not('.select2-container');
    $(sibling).removeClass('alert-warning').addClass('alert-danger')
    $(sibling).addClass('hidden')
    $(sibling).find('span').html('')

}

function afficherWarningNoLot(ctrl, warning) {
    if (ctrl.hasClass('no-lots') && warning !== undefined) {
        ctrl.parent().addClass('has-warning')
        let sibling = ctrl.siblings().not('.select2-container');
        $(sibling).removeClass('alert-danger').addClass('alert-warning')
        $(sibling).removeClass('hidden')
        $(sibling).find('span').html(warning)
    }
}
